<template>
  <p class="conditions">
    <input
      type="checkbox"
      :checked="modelValue"
      @click="emit('update:modelValue', $event.target.checked)"
    />
    я принимаю
    <a class="link-conditions" href="/policy" @click.prevent="policy"
      >условия политики конфиденциальности и обработки информации</a
    >
  </p>
  <Teleport to="body" v-if="show">
    <ModalConditions @closed="show = false" />
  </Teleport>
</template>

<script setup>
const { isModal } = useModal();
const props = defineProps(["modelValue"]);
const emit = defineEmits(["update:modelValue"]);
const show = ref();
const policy = () => {
  if (!isModal) return navigateTo('/policy');
  show.value = true;
};
</script>
